import {
  ADD_ASSOCIATE, DELETE_ASSOCIATE, REFRESH_ASSOCIATES, UPDATE_ASSOCIATE, UNLINK_ASSOCIATE,
  UPDATE_ASSOCIATE_NOTIFICATION_SETTINGS, GET_ASSOCIATE_NOTIFICATION_SETTINGS
} from "../actions/associate.action";

const initialState = {
  associates: [],
  associateNotificationSettings: {},
};

// Helper function to sort associates by name
const sortAssociatesByName = (associates) => {
  return [...associates].sort((a, b) => {
    const nameA = (a.name || '').toLowerCase();
    const nameB = (b.name || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });
};

const associateReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_ASSOCIATES:
      return {
        ...state,
        associates: sortAssociatesByName(action.associates),
      };
    case ADD_ASSOCIATE:
      return {
        ...state,
        associates: sortAssociatesByName([...state.associates, action.associate]),
      };
    case GET_ASSOCIATE_NOTIFICATION_SETTINGS:
      return {
        ...state,
        associateNotificationSettings: {
          ...state.associateNotificationSettings,
          ...action.associateNotificationSettings,
        },
      };
    case UPDATE_ASSOCIATE_NOTIFICATION_SETTINGS:
      return {
        ...state,
        associateNotificationSettings: {
          ...state.associateNotificationSettings,
          ...action.associateNotificationSettings,
        },
      };
    case UPDATE_ASSOCIATE:
      const updatedAssociates = state.associates.map((associate) =>
        associate.id === action.associate.id ? action.associate : associate
      );
      return {
        ...state,
        associates: sortAssociatesByName(updatedAssociates),
      };
    case DELETE_ASSOCIATE:
      return {
        ...state,
        associates: state.associates.filter((associate) => associate.id !== action.associateId),
      };
    case UNLINK_ASSOCIATE:
      const unlinkedAssociates = state.associates.map((associate) =>
        associate.id === action.associateId
          ? (({ userId, ...rest }) => rest)(associate)
          : associate
      );
      return {
        ...state,
        associates: sortAssociatesByName(unlinkedAssociates),
      };
    default:
      return state;
  }
};

export default associateReducer;
